

























































































































import { Component, Vue } from 'vue-property-decorator';
import PageHeader from '@/components/common/PageHeader.vue';
import NewUsageSummary from '@/components/admin/NewUsageSummary.vue';
import TotalUsageSummary from '@/components/admin/TotalUsageSummary.vue';
import SidebarInfo from '@/components/common/SidebarInfo.vue';
import csvExportDialog from '@/csv-export-dialog';

@Component({
  components: {
    PageHeader,
    SidebarInfo,
    NewUsageSummary,
    TotalUsageSummary,
  },
})
export default class AdminDashboard extends Vue {
  showExportDialog() {
    csvExportDialog();
  }
}
